import React from 'react';
import Flagship from '../../core/flagship';
import {Link} from 'react-router';
import ClientAddModal from '../modals/ClientAddModal';
import {Dropdown, Segment, Button, Icon, Divider, Label} from 'semantic-ui-react';
import {throttle, empty} from '../../utils/helpers';

class ClientField extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = this.getInitialState();
        this.onSearchChange = this.onSearchChange.bind(this);
        this.addNewClient = this.addNewClient.bind(this);
        this.onAddClient = this.onAddClient.bind(this);
        this.cancelAddNew = this.cancelAddNew.bind(this);
    }

    getInitialState() {
        return {
            searchResults: [],
            emptySearch: false,
            addingClient: false,
            newClientName: null
        }
    }

    searchClients(like) {
        let self = this;

        Flagship.get(
            "dropdown-search/client",
            {
                "search": like
            },
            function(response) {
                if (response.data.success === true) {

                    self.setState({
                        searchResults: response.data.results,
                        emptySearch: (empty(response.data.results) || response.data.results.length === 0)
                    });

                } else {
                    Flagship.error("Could not retrieve dropdown search results for client field. Query: " + like, 0, 0);
                }
            }, function(err) {
                Flagship.error("An error occurred in dropdown search: " + err, 0, 0);
            }
        );
    }

    addNewClient() {

        this.setState({
            addingClient: true
        });


    }

    onAddClient(id, link, key, name) {

        if (typeof this.props.onAddClient === "function") {
            this.props.onAddClient(id, link, key, name);
        }
    }


    cancelAddNew() {
        this.setState({
            newClientName: null,
            addingClient: false
        });
    }

    onSearchChange(e, data) {

        let search = this.searchClients.bind(this);
        this.timer = throttle( function() {
            search(data);
        }, 400, this.timer);
    }


    render() {

        if(!empty(this.props.value)) {
            return (
                <div>
                    <Label className="multi-field-label" size="large">
                        {this.props.label}
                        {this.props.required === "1" || this.props.required === true || this.props.required === 1 ?
                            <Icon color="red" size="tiny" className="asterisk" name="asterisk" />
                            : null
                        }
                    </Label>
                <Segment compact>
                    <h3 className="attachment-record-link">
                        <Icon className="feed-icon" disabled size="large" color="grey" name="briefcase" />
                        <Link style={{display:"inline-block", verticalAlign: "middle"}} to={'/client/view/' + this.props.value.key}>{this.props.value.name}</Link>
                    </h3>
                    <Divider hidden />
                    <Button secondary onClick={this.props.onReset} content="Change Client" />
                </Segment>
                </div>

            );
        }
        return (
            <div>
                <Label className="single-field-label" size="large">
                    {this.props.label}
                    {this.props.required === "1" || this.props.required === true || this.props.required === 1 ?
                        <Icon color="red" size="tiny" className="asterisk" name="asterisk" />
                        : null
                    }
                </Label>
                <Dropdown className="client-search" {...this.props} fluid search selection onSearchChange={this.onSearchChange.bind(this)} options={this.state.searchResults} />
                {this.state.emptySearch === true ?
                    <Button
                        className="add-new-client-btn"
                        content="Add New..."
                        onClick={this.addNewClient}
                    />
                    : null}


                {this.state.addingClient === true ?
                <ClientAddModal
                    open={true}
                    cancelAddNew={this.cancelAddNew.bind(this)}
                    recordId={this.props.recordId}
                    name={this.state.newClientName}
                    onAddClient={this.onAddClient}
                /> : null }

            </div>
        );

    }

}

export default ClientField;



// WEBPACK FOOTER //
// ./src/components/records/ClientField.js